import { createFileRoute } from '@tanstack/react-router';
import { ArticleCard } from '@/common/ArticleCard';
import { ArticleListingPage } from '@/common/ArticleListingPage';
import { kindForRole, usePostsFeed } from '@/posts/posts';
import { newsCategoriesData } from '@/posts/postsSidebars';
import { useCurrentUser } from '~/hooks/useCurrentUser';

export const Route = createFileRoute('/_app/news/')({
  component: NewsScreen,
});

export default function NewsScreen() {
  const { me, isStudyHelper, isPending } = useCurrentUser();
  // Wait for the role before asking for a kind — a guess fetches the wrong
  // stream and then immediately re-fetches the right one.
  const { items, isLoading, hasMore, loadMore } = usePostsFeed(
    kindForRole(isStudyHelper, 'news'),
    me?.language ?? 'EN',
    { enabled: !isPending },
  );

  return (
    <ArticleListingPage
      items={items}
      isLoading={isLoading}
      hasMore={hasMore}
      onLoadMore={loadMore}
      sidebarData={newsCategoriesData}
      renderCard={(news) => (
        <ArticleCard
          key={news.slug}
          slug={news.slug}
          title={news.title}
          date={news.date}
          description={news.description}
          imageUrl={news.imageUrl}
          basePath="/news"
        />
      )}
    />
  );
}
